export const LAYOUT_MAIN_ELEMENT_ID = 'layout-main';
